const root = window.location.origin || "";

export default [
  {
    groupHeader: "Products",
    children: [
      { name: "Folding Doors", url: root + "/products/folding-doors" },
      { name: "Sliding Doors", url: root + "/products/sliding-doors" },
      { name: "Swing Doors", url: root + "/products/swing-doors" },
      { name: "Screens", url: root + "/products/screens" },
      { name: "Servery Windows", url: root + "/products/windows/servery-window" }
    ],
  },
  {
    groupHeader: "Gallery",
    children: [
      {
        name: "Residential",
        url: root + "/image-gallery/category/Residential",
      },
      {
        name: "Development/Multi-Family",
        url: root + "/image-gallery/category/Development-Multi-Family",
      },
      {
        name: "Restaurants/Retail",
        url: root + "/image-gallery/category/Restaurant-Retail",
      },
      {
        name: "Resort/Hotels",
        url: root + "/image-gallery/category/Resort-Hotel",
      },
      {
        name: "Education/Office",
        url: root + "/image-gallery/category/Education-Office",
      },
      { name: "Video Gallery", url: root + "/video-gallery" },
      { "name": "Submit Your Project", "url": "/submit-your-project" }
    ],
  },
  {
    groupHeader: "Learn",
    children: [
      { name: "Interactive Videos", url: root + "/learn/interactive-videos" },
      { name: "Performance", url: root + "/learn/performance" },
      { name: "Applications", url: root + "/learn/applications" },
      { name: "Featured Projects ", url: root + "/learn/featured-projects" },
      { name: "Green Design ", url: root + "/learn/green-design" },
      { name: "Continuing Education", url: root + "/professionals/architects-designers-builders#CEU" },
      { name: "Blog", url: root + "/blog" },
    ],
  },
  {
    groupHeader: "Professionals",
    children: [
      {
        name: "Architects, Designers, Builders",
        url: root + "/professionals/architects-designers-builders",
      },
      { name: "Dealers", url: root + "/professionals/dealers" },
      {
        name: "Technical Documents",
        url: root + "/support/technical-documents",
      },
      { name: "Continuing Education", url: root + "/professionals/architects-designers-builders#CEU" },
      { "name": "Submit Your Project", "url": "/submit-your-project" }
    ],
  },
  {
    groupHeader: "Support",
    children: [
      { name: "Support Options", url: root + "/support" },
      { name: "Customer Service", url: root + "/request-service" },
      { name: "Warranty", url: root + "/support/warranty" },
      { name: "FAQ", url: root + "/support/faqs" },
      { name: "Installation", url: root + "/support/installation" },
      {
        name: "Technical Documents",
        url: root + "/support/technical-documents",
      },
    ],
  },
  {
    groupHeader: "About",
    children: [
      { name: "About Us", url: root + "/about" },
      { name: "Blog", url: root + "/blog" },
      { name: "Why LaCantina", url: root + "/about/why-lacantina" },
      { name: "Contact Us", url: root + "/about/contact" },
      // { name: "News", url: root + "/about/news" },
      { name: "Careers", url: root + "/about/careers" },
      // { name: "Partners", url: root + "/about/partners" },
      // { name: "Testimonials", url: root + "/about/testimonials" },
    ],
  },
];
